import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  container: {
    marginBottom: '120px',
  },
}));
